import { useTranslation } from "react-i18next";
import DynamicTextArea from "../DynamicTextArea";
import { TitleDescriptionObject } from "../../Types/TableTypes";


interface TitleDescriptionComponentListProps{
    sectionTitle: string,
    list: TitleDescriptionObject[],
    updateValues: (subtext: string, componentValues: TitleDescriptionObject[])=> void
    editMode: boolean
    subtext: string,
    column: boolean
}

const TitleDescriptionListComponent = (props: TitleDescriptionComponentListProps)=>{
    const { t } = useTranslation();
    
    return (
        <div className="mt-2 mb-2 ms-4 me-4">
            <div>
                <h3 >{props.sectionTitle}
                    {props.editMode && <span role="button" onClick={e=>{
                            props.list.push({title:"", description:""});
                            props.updateValues(props.subtext, props.list);
                        }
                    }>
                        &nbsp;<i className="bi bi-plus-circle"></i>
                    </span>}
                </h3>
                <div className="divider"></div>
            </div>
            {props.editMode ?<div>
                <DynamicTextArea
                    updateText={(text: string)=>{
                        props.updateValues(text, props.list);
                    }}      
                    placeholder={t("placeholder-subtext")}
                    areaText={props.subtext}/>
                
            </div>:
            props.subtext !== "" ? 
            <div>
                <span>{props.subtext}</span>
            </div>
            :<></>}
            {props.list && props.list.map((row, index)=>{return(
                <div className={(props.editMode || props.column ? "flex-column " : " ") +"d-flex mb-2"} key={index}>
                    {
                        props.editMode ? 
                            <span className="input-group">

                                <input 
                                value={row.title}
                                type="text"
                                placeholder={t("placeholder-title")}
                                className="form-control"
                                onChange={e => {
                                    props.list[index].title = ((e.target.value));
                                    props.updateValues(props.subtext, props.list);
                                }}
                            ></input>
                            <span className="input-group-text" role="button" 
                                onClick={e=>{
                                    props.list.splice(index, 1);
                                    props.updateValues(props.subtext, props.list);
                                }}
                            ><i className="bi bi-trash3-fill"></i></span>
                        </span>
                        :
                        <span><b>{row.title}&nbsp;</b></span>
                    }
                        
                    {
                        props.editMode ? 
                            <DynamicTextArea
                                updateText={(text: string)=>{
                                    props.list[index].description = text;
                                    props.updateValues(props.subtext, props.list);
                                }}      
                                placeholder={t("placeholder-description")}
                                areaText={row.description}/>
                        :
                        <span>{row.description}</span>
                    }
                </div>
            )})}
        </div>
    )
}

export default TitleDescriptionListComponent;